import React from 'react';
import Flatpickr from 'react-flatpickr';
import '../Scheduling.css';

export function Calendar({ onChange, currentMonth, selectedDate, filterDate }) {
  const today = new Date();
  // const oneDayInMilliseconds = 86400000;

  const firstDayOfMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    1,
  );

  const lastDayOfMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth() + 1,
    0,
  );

  const isDateAllowed = (date) => {
    return filterDate.some(
      (filterDate) =>
        date.getFullYear() === filterDate.getFullYear() &&
        date.getMonth() === filterDate.getMonth() &&
        date.getDate() === filterDate.getDate(),
    );
  };

  const optionsFlatPicker = {
    locale: {
      months: {
        longhand: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
        shorthand: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
      },
      weekdays: {
        longhand: [
          'Domingo',
          'Segunda-feira',
          'Terça-feira',
          'Quarta-feira',
          'Quinta-feira',
          'Sexta-feira',
          'Sábado',
        ],
        shorthand: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      },
    },
    inline: true,
    defaultDate: selectedDate || today,
    minDate: firstDayOfMonth,
    maxDate: lastDayOfMonth,
    dateFormat: 'd/m/Y',
    allowInput: true,
    altInput: true,
    altFormat: 'd/m/Y',
    monthSelectorType: 'static',
    // disable: [
    //   {
    //     from: new Date(0),
    //     to: new Date(today.getTime() - oneDayInMilliseconds),
    //   },
    // ],
    prevArrow: '',
    nextArrow: '',
    onChange: (selectedDates, dateStr) => {
      onChange(selectedDates[0]);
    },
    onClose: function (selectedDates) {
      const selectedDate = selectedDates[0];
      const adjustedSelectedDate = new Date(
        Math.min(Math.max(selectedDate, firstDayOfMonth), lastDayOfMonth),
      );
      onChange(adjustedSelectedDate);
    },
    onDayCreate: (dObj, dStr, fp, dayElem) => {
      const date = new Date(dayElem.dateObj);
      if (isDateAllowed(date)) {
        if (date === today) dayElem.classList.add('date-today');
        if (date < today) {
          dayElem.classList.add('past-event');
        } else {
          dayElem.classList.add('future-event');
        }
      }
    },
  };

  return (
    <Flatpickr
      required
      className="d-none"
      value={selectedDate || today}
      style={{
        borderBottom: 'none',
        textShadow: '-1px 1px 1px #000',
      }}
      placeholder="Selecione a data"
      options={optionsFlatPicker}
    />
  );
}
